import React from 'react'
import PropTypes from 'prop-types'

export function HeaderBanner({children}) {
  return <div className="header-banner">{children}</div>
}

HeaderBanner.propTypes = {
  children: PropTypes.node,
}

export default HeaderBanner
